var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12519_21358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.267 9.65286C20.2279 9.60373 19.292 8.43674 17.6341 7.26471C15.43 5.70648 12.9823 4.88281 10.5555 4.88281C8.12878 4.88281 5.68112 5.70648 3.47699 7.26471C1.81912 8.43674 0.883148 9.60373 0.844086 9.65286L0.555542 10.0157L0.844086 10.3787C0.883148 10.4279 1.81912 11.5948 3.47699 12.7669C5.68112 14.3251 8.12878 15.1488 10.5555 15.1488C12.9823 15.1488 15.43 14.3251 17.6341 12.7669C19.292 11.5948 20.2279 10.4279 20.267 10.3787L20.5555 10.0157L20.267 9.65286ZM14.5219 10.0157C14.5219 12.168 12.7989 13.9253 10.6599 13.9807C10.625 13.9812 10.5905 13.9821 10.5555 13.9821C10.5206 13.9821 10.4861 13.9812 10.4512 13.9807C8.31219 13.9253 6.58917 12.168 6.58917 10.0157C6.58917 7.86362 8.31219 6.10626 10.4512 6.05072C10.4861 6.05042 10.5206 6.04935 10.5555 6.04935C10.5905 6.04935 10.625 6.05042 10.6599 6.05072C12.7989 6.10626 14.5219 7.86362 14.5219 10.0157ZM2.07837 10.0157C2.46396 9.60297 3.18509 8.89572 4.18027 8.19611C4.79031 7.76733 5.56226 7.3024 6.46771 6.91528C5.81235 7.77725 5.42264 8.85178 5.42264 10.0157C5.42264 11.1797 5.81235 12.2542 6.46771 13.1163C5.56226 12.729 4.79031 12.2643 4.18027 11.8353C3.18509 11.1359 2.46381 10.4285 2.07837 10.0157ZM16.9308 11.8353C16.3208 12.2643 15.5488 12.7292 14.6434 13.1163C15.2987 12.2543 15.6884 11.1797 15.6884 10.0157C15.6884 8.85178 15.2989 7.77725 14.6434 6.91528C15.5488 7.3024 16.3208 7.76733 16.9308 8.19611C17.926 8.89572 18.6473 9.60312 19.0329 10.0157C18.6471 10.4286 17.926 11.1359 16.9308 11.8353Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.555542)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.adb0dbb8c64e5f4868e0ed37ca18e6c3.svg";
export { ForwardRef as ReactComponent };